import React from 'react';
import { useParams } from 'react-router-dom';
import DisplayViewer from '../../components/display/DisplayViewer';

/**
 * DisplayViewerPage Component
 * 
 * A clean, full-screen page for displaying the display viewer
 * without any header, footer, or other distractions
 */

interface DisplayViewerPageParams {
  [key: string]: string | undefined;
  displayId?: string;
  token?: string;
}

const DisplayViewerPage: React.FC = () => {
  const { displayId, token } = useParams<DisplayViewerPageParams>();

  return (
    <div className="display-viewer-page">
      {/* No header, navigation, or other UI elements to create a clean display */}
      <DisplayViewer
        displayId={displayId}
        authToken={token}
      />
    </div>
  );
};

export default DisplayViewerPage; 